import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import { translate } from 'react-i18next';

const formItemLayout = {
    labelCol: {
      xs: {
        span: 9,
      },
      sm: {
        span: 12,
      },
    },
    wrapperCol: {
      xs: {
        span: 15,
      },
      sm: {
        span: 12,
      },
    },
  };
  
  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 12,
        offset: 7,
      },
    },
  };

class BiometricVerificationResult extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        biometricsData: PropTypes.object.isRequired,
        accountDocuments: PropTypes.array.isRequired,
        token: PropTypes.string.isRequired,
    };

    render() {
        const { t, biometricsData, accountDocuments, token } = this.props;
        
        const frontImage = accountDocuments.find(doc => doc.type === "ID_CARD_SCAN_FRONT");
        const backImage = accountDocuments.find(doc => doc.type === "ID_CARD_SCAN_BACK");
        const faceImage = accountDocuments.find(doc => doc.type === "FACE_IMAGE");

        return (
            <div>
                <Form.Item {...tailFormItemLayout}>
                    <h3>{t('Výsledok overenia biometrie')}</h3>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Meno')}>
                <div>{biometricsData.name}</div>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Priezvisko')}>
                <span>{biometricsData.surname}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Rodné priezvisko')}>
                <span>{biometricsData.birth_surname}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Pohlavie')}>
                <span>{biometricsData.sex}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Národnosť')}>
                <span>{biometricsData.nationality}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Dátum narodenia')}>
                <span>{biometricsData.date_birth}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Rodné číslo')}>
                <span>{biometricsData.birth_number}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Číslo občianskeho preukazu')}>
                <span>{biometricsData.number}</span>
                </Form.Item>

                <Form.Item {...formItemLayout} label={t('Adresa')}>
                <span>{biometricsData.address}</span>
                </Form.Item>

                {biometricsData.notes && 
                <Form.Item {...formItemLayout} label={t('Poznámka')}>
                    <span>{biometricsData.notes}</span>
                </Form.Item>
                }

                { frontImage && (
                    <Form.Item {...formItemLayout} label={t('Predná strana OP')}>
                        <span>
                            <a
                                href={`${frontImage.file.link}?token=${token}`}
                                target="_blank" 
                                rel="noopener noreferrer"
                            >{t('Otvoriť')}</a>
                        </span>
                    </Form.Item>
                )}

                { backImage && (
                    <Form.Item {...formItemLayout} label={t('Zadná strana OP')}>
                        <span>
                            <a
                                href={`${backImage.file.link}?token=${token}`}
                                target="_blank" 
                                rel="noopener noreferrer"
                            >{t('Otvoriť')}</a>
                        </span>
                    </Form.Item>
                )}

                { faceImage && (
                    <Form.Item {...formItemLayout} label={t('Fotka tváre')}>
                        <span>
                            <a
                                href={`${faceImage.file.link}?token=${token}`}
                                target="_blank" 
                                rel="noopener noreferrer"
                            >{t('Otvoriť')}</a>
                        </span>
                    </Form.Item>
                )}

                {
                  biometricsData.similarity &&
                  <Form.Item {...formItemLayout} label={t('Podobnosť tváre')}>
                      <span>{biometricsData.similarity.toFixed(2)} %</span>
                  </Form.Item>
                }

            </div>
        );
    }
}

export default translate()(BiometricVerificationResult);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/BiometricsVerificationResult.js